// extracted by mini-css-extract-plugin
module.exports = {"orderStatus":"SpecialStatus_orderStatus__llhLG"};